import { formatearFechaSinHora } from "@shared/utils/date.utils";
import { ISancion } from "./expediente.interface";

export class Sancion implements ISancion {
    id: number;
    porcentaje: string;
    monto: string;
    dias: number;
    pasada: number;
    sancion_previa: string;
    fecha: string;

    get porcentaje_cumplimiento(): string {
        return this.porcentaje + "%";
    }

    get monto_multa(): string {
        return Number.isInteger(this.monto) ? this.monto + " UTM" : "No Aplica";
    }

    get dias_suspension(): string {
        return Number.isInteger(this.dias) ? this.dias.toString() : "No Aplica";
    }

    get fechaSinHora(): string {
        return formatearFechaSinHora(this.fecha);
    }
}